import { createPortal } from 'react-dom';
import { useState, useLayoutEffect } from 'react';

// create portal just with this id
const portalIds = [
  'react-portal-modal-container',
  'react-portal-tooltip-container',
  'react-portal-toast-container',
  'react-portal-confirmation-container',
  'react-portal-alert-container',
];

const createWrapperAndAppendToBody = (wrapperId, position) => {
  if (wrapperId === 'react-portal-toast-container') {
    const wrapperElement = document.createElement('div');
    // assign id to created div
    wrapperElement.setAttribute('id', wrapperId);
    // console.log({ className, wrapperId });
    wrapperElement.setAttribute('class', `position-${position}`);
    // wrapperElement.setAttribute("id", wrapperId);
    // add div to body tag of project
    document.body.appendChild(wrapperElement);
    return wrapperElement;
  } else {
    const wrapperElement = document.createElement('div');
    // assign id to created div
    wrapperElement.setAttribute('id', wrapperId);
    // add div to body tag of project
    document.body.appendChild(wrapperElement);
    return wrapperElement;
  }
  // create div element
};

export const ReactPortal = ({
  children,
  wrapperId = 'react-portal-wrapper',
  position = '',
}) => {
  const [wrapperElement, setWrapperElement] = useState(null);

  useLayoutEffect(() => {
    let element = document.getElementById(wrapperId);
    let systemCreated = false;
    // if element is not found with wrapperId or wrapperId is not provided,
    // create and append to body
    if (!element && portalIds.includes(wrapperId)) {
      systemCreated = true;
      element = createWrapperAndAppendToBody(wrapperId, position);
    }
    setWrapperElement(element);

    return () => {
      // delete the programatically created element
      if (systemCreated && element.parentNode && element.children.length == 1) {
        element.parentNode.removeChild(element);
      }
    };
  }, [wrapperId]);

  // wrapperElement state will be null on very first render.
  if (wrapperElement === null) return null;

  return createPortal(children, wrapperElement);
};

export default ReactPortal;
